import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 48,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(23px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#00B7A4',
        opacity: 1,
        border: 'none',
      },
      '& + $thumb': {
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid black',
    },
  },
  thumb: {
    width: 16,
    height: 16,
    border: '1px solid black',
    color: 'white',
    '$checked$checked + &': {
      border: 'none',
    },
  },
  track: {
    borderRadius: 24 / 2,
    border: '1px solid black',
    backgroundColor: theme.palette.primary.contrastText,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
    '$checked$checked + &': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      data-testid="ios-switch"
      {...props}
    />
  )
})

export default IOSSwitch
